import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import fire from "./Firebase";
import "../App.css";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as htmlToImage from "html-to-image";

function Try3() {
  const conponentPDF = useRef();
  const [usercertificate3, setusercertificate3] = useState([]);
  const domEl = useRef({});
  const downloadImage = async () => {
    const dataUrl = await htmlToImage.toJpeg(domEl.current);

    // download image
    const link = document.createElement("a");
    link.download = "html-to-img.jpeg";
    link.href = dataUrl;
    link.click();
  };
  useEffect(() => {
    fire
      .child(`certificates/${sessionStorage.getItem("lastname3")}`)
      .on("value", (sna) => {
        setusercertificate3([sna.val()]);
      });
  }, []);
  // const generatePDF2 = useReactToPrint({
  //   content: () => conponentPDF.current,
  //   documentTitle: "Userdata",
  //   onAfterPrint: () => toast("Data saved in PDF"),
  // });
  return (
    <div>
      <Header />
      <div>
        {usercertificate3.map((datas3) => {
          return (
            <>
              <div className="certicontainer" ref={domEl} style={{textTransform:"uppercase"}}>
                <div className="certititle">HR SCHOOL</div>
                <div className="certititle">CERTIFICATE OF COMPLETION</div>
                <div className="certiline"></div>
                <div className="certicourse-title">
                  CERTIFIED {datas3.Field} SPECIALIST
                </div>
                <div className="certihours-value">THIS IS TO CERTIFY THAT</div>
                <div className="certihours">
                  NAME :- {datas3.Gender} {datas3.Name}
                </div>
                <div className="certihours">FATHER NAME :- {datas3.Father}</div>
                <div className="certihours">
                  COURSE DURATION :- {datas3.Course} MONTHS
                </div>
                <div className="certihours">
                  COURSE NAME :- {datas3.Coursename}
                </div>
                <div className="certitext-bold">
                  THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN TAKE IT
                  AWAY FROM YOU.
                </div>
                <div className="certitext">
                  HAS SUCCESSFULLY COMPLETED THE {datas3.Coursename} COURSE WITH
                  LOKI SCHOOL
                </div>
                <div className="certismall-line"></div>
                <div className="certisubtitle">
                  WITH SCORE OF {datas3.grade}
                </div>
                <div className="certismall-line"></div>
                <div className="certisubtitle">Date</div>
                <div className="certisubtitle">
                  START DATE :- {datas3.startdate}/{datas3.startmonth}/
                  {datas3.startyear}
                </div>
                <div className="certisubtitle">
                  END DATE :-{datas3.enddate} /{datas3.endmonth}/
                  {datas3.endyear}
                </div>
                <div className="certisubtitle">www.hrschool.com</div>
              </div>
            </>
          );
        })}
      </div>
      <center>
        {/* <button className="non-printable" onClick={() => generatePDF2()}>
          Convert In PDF
        </button> */}
        <button onClick={downloadImage} style={{ color: "black" }}>Download Image</button>
      </center>
    </div>
  );
}

export default Try3;
